const copyUrl = () => {
  const target = document.querySelector('.js-copy-link') as HTMLButtonElement;
  if (!target) return;

  const copyFunc = () => {
    const url = location.href;
    navigator.clipboard.writeText(url);
    target.textContent = 'URL Copied';
    target.style.backgroundColor = '#9c9d9d';
  };
  target.addEventListener('click', copyFunc);
};

export { copyUrl };
